import { cn, createBEM } from "@/libs"
import './index.scss';
import { useToggle } from "ahooks";
import { useNavigate } from "react-router-dom";
import { useUserInfoStore } from "@/stores/userInfo";
export const EarnIcon = () => {
  const [state, { toggle }] = useToggle(false);
  const b = createBEM('i-earn-icon');
  const navigate = useNavigate();
  const [userInfo] = useUserInfoStore()((state) => [state.userInfo]);
  const navigateToEarnDetail = () => {
    navigate(userInfo.BusinessStatus ===1 ? '/root/crypto_earn':'/root/crypto_earn_agree');
  }
  return <div className={b()}>
     <div className={cn(b('banner'), state? 'show' : '')} onClick={() => navigateToEarnDetail()}></div> 
    <div className={b('btn')} onClick={() => toggle()}></div>
  </div>
}